import React from 'react'
import { Button, Row } from 'antd'
import { CustomCol } from 'src/components'
import { useTranslation } from 'next-i18next'
import { useWindowSize } from 'src/app/hooks'

interface ButtonsContentProps {
  handleResetForm: () => void
  loading: boolean
}

const ButtonsContent: React.FC<ButtonsContentProps> = ({ handleResetForm, loading }) => {
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()

  return <Row className='mt-5'>
    <CustomCol className={!isMobile && 'p-5'}>
      <Button
        block
        size='large'
        type='default'
        htmlType='button'
        className='radius-100'
        onClick={handleResetForm}
      >{t('admin.Brokerage.ResetFormText')}
      </Button>
    </CustomCol>
    <CustomCol className={!isMobile && 'p-5'}>
      <Button
        block
        size='large'
        type='primary'
        htmlType='submit'
        loading={loading}
        style={{ marginTop: isMobile && '10px' }}
        className='radius-100 float-right'
      >{loading ? t('admin.Brokerage.CreatingBrokerage') : t('general.Submit')}
      </Button>
    </CustomCol>
  </Row>
}

export default ButtonsContent
